import React, { useEffect, useState , useRef } from "react"
import { Link, useParams } from "react-router-dom";
import img from './soulogo.png'
import star from './star.svg'
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import config from "../config/config";
import { useNavigate, useLocation } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import userAction, { setApiToken, setUserInfo } from "../actions/userActions";
import { getUserData, getUserInfoData } from "../actions/userdata";
import { Col, Row } from "react-bootstrap";
import { displayErrorString, getSouData } from "../Utils/utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LoadingSpinner from "../Components/LoadingSpinner";
import { exportAsPDF } from "../Utils/ExportData";
import { TimeUtils, getUpdatedDateWithTimezone } from "../Utils/TimeUtils";
import moment from "moment/moment";

const SouDetailExport = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState(new Date())
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const [data, setData] = useState('');
  const id = useParams()
  const pageRef = useRef();
  const location = useLocation();
  const [hasDownloaded, setHasDownloaded] = useState(false);
  const [newStartDate, setNewStartDate] = useState(moment().format('YYYY-MM-DD'))
    const [newEndDate, setNewEndDate] = useState(moment().format('YYYY-MM-DD'))
  
  


  const getSou = async (id) => {
    var res = await getSouData(id)
    if (res.status == 200) {
      setData(res.data)
      let newSD = getUpdatedDateWithTimezone(res.data?.new_start_date, res.data?.selected_schedule, res.data?.TIMEZONE)
       setNewStartDate(newSD)

       let endSD = getUpdatedDateWithTimezone(res.data?.new_end_date, res.data?.selected_schedule, res.data?.TIMEZONE)
             setNewEndDate(endSD)
    }
  }
  useEffect(() => {
    getSou(id?.id)
  }, [])

  useEffect(() => {
    if (location.state?.download && !hasDownloaded) {
      if (data) {
        exportAsPDF(pageRef, `souDetail_${id?.id}.pdf`);
        setHasDownloaded(true); 
      }
    }
  }, [data, location.state, id, hasDownloaded]);

  return (
    <>
      <LoadingSpinner isLoading={isLoading} />
      <ToastContainer
        position="top-center"
      />
      <div ref={pageRef}>
        <div>
          <div>
            <img src={img} style={{ width: '100%' }} />
          </div>

          <div className="m-4">
          <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginTop:'-20px'}}>
            <h1 style={{fontWeight:'600', fontFamily:'normal',color:'#000'}}>SECTION I: Student Information</h1>
          </div>
          <Row className="mt-2">
            <div style={{marginBottom:'-12px'}}>
                <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>First Name: {data?.FIRSTNAME}</p>
            </div>
            <div style={{marginBottom:'-12px'}}>
                <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>Last Name: {data?.LASTNAME}</p>
            </div>
            <div>
                <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>Email: {data?.HOME_EMAIL}</p>
            </div>
          </Row>


          <div className="my-4">
            <p style={{fontSize:'20px', color:'#555',fontFamily:'normal', fontSize:'26px',color:'#000'}}>Based on your availability and training requirements, you have been placed in an eMentor course. By checking the boxes below, you are agreeing to the following schedule:</p>
          </div>
          <Row>
                <div style={{marginBottom:'-12px'}}>
                    <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>Course Number: {data?.serialized_course_number}</p>
                </div>
                <div style={{marginBottom:'-12px'}}>
                    <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>Course Type: {data?.COURSETYPE}</p>
                </div>
                <div style={{marginBottom:'-12px'}}>
                    <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>Language: {data?.LANGUAGE}</p>
                </div>
                <div style={{marginBottom:'-12px'}}>
                    <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>Time Zone: {data?.TIMEZONE}</p>
                </div>
                <div style={{marginBottom:'-12px'}}>
                    <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>Start Date: {newStartDate}</p>
                </div>
                <div style={{marginBottom:'-12px'}}>
                    <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>End Date: {
                    data?.new_end_date ? moment(newEndDate).format('MM/DD/YYYY'):  data?.serialized_course_number ? data?.serialized_course_number.split('-')[1]?.startsWith('30')
                              ? moment(newStartDate).add(3, 'weeks').format('MM/DD/YYYY')
                              : moment(newStartDate).add(10, 'weeks').format('MM/DD/YYYY') : ''
                            }</p>
                </div>
                <div style={{marginBottom:'-12px'}}>
                    <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>Schedule: {TimeUtils(data?.selected_schedule, data?.TIMEZONE)}</p>
                </div>
                 <div style={{marginBottom:'-12px'}}>
                    <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>Course Duration: {
                    data?.serialized_course_number ? data?.serialized_course_number.split('-')[1]?.startsWith('30')
                              ? 12
                              : 40 : 40
                            } Hours </p>
                </div>
          </Row>

          <div>
            <div className="my-4">
                <h1 style={{fontWeight:'600',fontFamily:'normal', color:'#000'}}>SECTION II: Student Acknowledgment</h1>
            </div>
            <div style={{display:'flex', alignItems:'baseline', marginBottom:'-10px'}}>
                <div>
                    <img src={star} style={{ width: '16px', height:'16px', marginBottom:'5px' }} />
                </div>
                <p style={{marginLeft:'10px', fontSize:'22px',fontFamily:'normal'}}>I have read the LEAP Policy and understand the expectations related to my LEAP Level development and sustainment as well as the eMentor requirements,
                homework expectations, final scores, etc.</p>
            </div>

            <div style={{display:'flex', alignItems:'baseline',marginBottom:'-10px'}}>
                <div>
                    <img src={star} style={{ width: '12px', height:'12px', marginBottom:'5px' }} />
                </div>
                <p style={{marginLeft:'10px',fontSize:'22px' ,fontFamily:'normal'}}>I will make every effort to attend all classes. I understand I am required to attend the first class and complete the final summative assessment. Fail
                ure to meet this requirement will result in not receiving course credit/scores.</p>
            </div>

            <div style={{display:'flex', alignItems:'baseline',marginBottom:'-10px'}}>
                <div>
                    <img src={star} style={{ width: '12px', height:'12px', marginBottom:'5px' }} />
                </div>
                <p style={{marginLeft:'10px',fontSize:'22px' ,fontFamily:'normal'}}> I agree to attend 80% or more of the total classes (32 hours of a 40-hour course/10 hours of a 12-hour course). Failure to meet this requirement will
                result in not receiving course credit/scores.</p>
            </div>

            <div style={{display:'flex', alignItems:'baseline',marginBottom:'-10px'}}>
                <div>
                    <img src={star} style={{ width: '12px', height:'12px', marginBottom:'5px' }} />
                </div>
                <p style={{marginLeft:'10px',fontSize:'22px' ,fontFamily:'normal'}}>I will make every effort to complete the homework assigned after every session.</p>
            </div>

            <div style={{display:'flex', alignItems:'baseline',marginBottom:'-10px'}}>
                <div>
                    <img src={star} style={{ width: '12px', height:'12px', marginBottom:'5px' }} />
                </div>
                <p style={{marginLeft:'10px', fontSize:'22px' ,fontFamily:'normal'}}>I am not scheduled for a Language Intensive Training Event (LITE) or any other TDY that will conflict with this course.</p>
            </div>

            <div style={{display:'flex', alignItems:'baseline',marginBottom:'-10px'}}>
                <div>
                    <img src={star} style={{ width: '12px', height:'12px', marginBottom:'5px' }} />
                </div>
                <p style={{marginLeft:'10px', fontSize:'22px' ,fontFamily:'normal'}}>I understand that failure to complete the End of Course Survey will affect my ability to participate in future eMentor courses and LITEs.
                NOTE: Upon submission, the AFCLC will commit funds to your eMentor training.</p>
            </div>


            <div className="mt-1">
                <p style={{fontSize:'22px' ,fontFamily:'normal', color:'#000'}}>NOTE: Upon submission, the AFCLC will commit funds to your eMentor training.
                </p>
            </div>
          </div>


          <Row className="mt-2">
                <div style={{marginBottom:'-12px'}}>
                    <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>Signature: {`${data?.FIRSTNAME} ${data?.LASTNAME}`}</p>
                </div>
                  <div style={{display:'flex', alignItems:'baseline'}}>
                    <p style={{fontSize:'26px', color:'#000',fontFamily:'normal'}}>Signed On: </p>
                    <div>
                        <DatePicker
                            selected={startDate}
                            dateFormat="MM/dd/yyyy"
                            minDate={new Date()}
                        />
                    </div>
                  </div>
              </Row>
        </div>
        </div>
      </div >
    </>
  )
}
export default SouDetailExport;











